import { Component, inject, OnInit } from '@angular/core';
import { Company } from "@models/companies/company";
import { AsicAgentData } from '@models/settings/asic-agent-data';
import { SubMenuItem } from "@models/ui-models/section-form-menu";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonPageComponent } from "@shared/components/commons/common-page/common-page.component";
import { DividerComponent } from '@shared/components/commons/divider/divider.component';
import { LoaderComponent } from '@shared/components/commons/loader/loader.component';
import {
  AgActionIconButtonComponent
} from '@shared/components/grid/ag-cells/common/ag-action-icon-button/ag-action-icon-button.component';
import { AppCopyDirective } from '@shared/directives/copy.directive';
import { HasRoleDirective } from '@shared/directives/has-role.directive';
import { DefaulValuePipe } from '@shared/pipes/defaultValuePipe';
import { PhonePipe } from '@shared/pipes/phonePipe';
import { IPartialHeaderData } from "@shared/services/header.service";
import { SettingsApiService } from '@shared/services/settings-api.service';
import { ToastrService } from "ngx-toastr";
import { finalize } from 'rxjs';
import { AsicFormRA01, AsicFormRA04 } from "../../../../forms/models/company";
import { ModalFormsService } from "../../../../forms/services/modal-forms.service";
import { EditAgentProfileModalComponent } from './edit-agent-profile-modal/edit-agent-profile-modal.component';
import {
  EditAgentResetEdgePasswordModalComponent
} from './edit-agent-reset-edge-password-modal/edit-agent-reset-edge-password-modal.component';

@Component({
  selector: 'app-agent-settings',
  standalone: true,
  imports: [
    LoaderComponent,
    AppCopyDirective,
    DefaulValuePipe,
    DividerComponent,
    AgActionIconButtonComponent,
    PhonePipe,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    HasRoleDirective
  ],
  templateUrl: 'agent-settings-page.component.html',
  styleUrls: [
    'agent-settings-page.component.scss',
    '../../styles/settings-styles.scss'
  ]
})
export class AgentSettingsPageComponent extends CommonPageComponent implements OnInit {
  private modalFormsService = inject(ModalFormsService);
  private modalService = inject(NgbModal);
  private settingsService = inject(SettingsApiService);
  private toastr = inject(ToastrService);

  override readonly headerData: IPartialHeaderData = {
    title: 'Agent Details',
    iconClass: 'ic-asic-black-white-20',
    backPath: ['/settings']
  };
  readonly firstASICConnectionAlertMessage = 'We are currently connecting your account to ASIC. Please close this message and wait for further updates on the Alerts page.';

  public agentSettingsFormMenu: SubMenuItem[] = [
    // {
    //   title: 'Notification to Register, Change Details or Cease as an Agent',
    //   formName: 'Form RA01',
    //   action: () => this.openFormRa01(),
    // },
    // {
    //   title: 'Registered Agent Direct Debit Request',
    //   formName: 'Form RA04',
    //   action: () => this.openRa04DirectDebitRequestForm(),
    // },
  ];

  agent: AsicAgentData = new AsicAgentData();
  editAgentDetailsModalOpened = true;
  edgePasswordVisible = false;

  override ngOnInit(): void {
    super.ngOnInit();
    this.loadAgentDetails();
  }

  editAgent(): void {
    if (this.editAgentDetailsModalOpened || this.isLoading()) return;
    this.editAgentDetailsModalOpened = true;
    const beforeDismiss = () => confirm('Changes will not be saved. Do you want to proceed?');
    const modalRef = this.modalService.open(EditAgentProfileModalComponent, { size: 'lg', beforeDismiss });
    (modalRef.componentInstance as EditAgentProfileModalComponent).setupAgentSettings(structuredClone(this.agent));

    modalRef.result.then(
      (agent: AsicAgentData) => {
        this.toastr.success('Data saved successfully', 'Success');
        this.agent = agent;

        if (this.isFirstASICConnection) {
          alert(this.firstASICConnectionAlertMessage);
        }

        this.loadAgentDetails();
      },
      () => this.editAgentDetailsModalOpened = false
    );
  }

  resetEdgePassword(): void {
    if (this.resetEdgePasswordButtonDisabled)
      return;

    const modalRef = this.modalService.open(EditAgentResetEdgePasswordModalComponent, { size: 'sm', centered: true });

    modalRef.result
      .then(
        () => alert('We are currently connecting your account to ASIC. Please close this message and wait for further updates on the Alerts page.'),
        () => {
        }
      );
  }

  private loadAgentDetails(): void {
    this.isLoading.set(true);

    this.settingsService.getAgentSettings()
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: agent => {
          this.agent.patch(agent);
          this.editAgentDetailsModalOpened = false;
        },
        error: (error) => console.warn('[AgentSettingsComponent.getAgentSettings] error: ', error)
      });
  }

  get isFirstASICConnection(): boolean {
    return (!this.agent.edgeLogin.length && !this.agent.edgePassword.length);
  }

  get resetEdgePasswordButtonDisabled(): boolean {
    return this.isLoading() || this.isFirstASICConnection;
  }

  get modalOpened() {
    return this.modalFormsService.modalOpened;
  }

  public openFormRa01(): void {
    this.modalFormsService.openModalWithCompany(new AsicFormRA01(), new Company());
  }

  public openRa04DirectDebitRequestForm(): void {
    this.modalFormsService.openModalWithCompany(new AsicFormRA04(), new Company());
  }
}

